import gql from 'graphql-tag';

const CANCEL_SUBSCRIPTION = gql`
    mutation cancelSubscription(
        $subscriptionId: String!
        $cancellationReason: String
    ) {
        cancelSubscription(
            cancelSubscriptionInput: {
                subscriptionId: $subscriptionId
                cancellationReason: $cancellationReason
            }
        )
            {
                success
                message
            }
    }
`;

export default CANCEL_SUBSCRIPTION;